import { AlertTriangle, RefreshCw } from "lucide-react";

interface EnvErrorPageProps {
  missingVars: string[];
}

export function EnvErrorPage({ missingVars }: EnvErrorPageProps) {
  const isDev = import.meta.env.DEV;

  const handleReload = () => {
    window.location.reload();
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-4">
      <div className="max-w-md w-full text-center space-y-6">
        <div className="flex justify-center">
          <div className="h-16 w-16 rounded-full bg-destructive/10 flex items-center justify-center">
            <AlertTriangle className="h-8 w-8 text-destructive" />
          </div>
        </div>
        
        <div className="space-y-2">
          <h1 className="text-2xl font-bold text-foreground">
            Sovelluksen konfiguraatio puuttuu
          </h1>
          <p className="text-muted-foreground">
            {isDev 
              ? "Tarkista että ympäristömuuttujat on asetettu oikein."
              : "Sovellusta ei voitu käynnistää. Ota yhteyttä ylläpitoon."
            }
          </p>
        </div>

        {isDev && missingVars.length > 0 && (
          <div className="text-left p-4 bg-muted rounded-lg overflow-auto max-h-40">
            <p className="text-sm font-medium text-foreground mb-2">
              Puuttuvat tai virheelliset muuttujat:
            </p>
            <ul className="text-sm font-mono text-destructive space-y-1">
              {missingVars.map((varName, index) => (
                <li key={index}>• {varName}</li>
              ))}
            </ul>
          </div>
        )}

        <div className="flex justify-center">
          <button 
            onClick={handleReload} 
            className="inline-flex items-center gap-2 px-4 py-2 bg-primary text-primary-foreground rounded-md hover:bg-primary/90 transition-colors"
          >
            <RefreshCw className="h-4 w-4" />
            Lataa sivu uudelleen
          </button>
        </div>

        {isDev && (
          <p className="text-xs text-muted-foreground">
            Varmista että .env-tiedosto on olemassa ja sisältää vaaditut muuttujat.
          </p>
        )}
      </div>
    </div>
  );
}
